import { render, staticRenderFns } from "./main-form.vue?vue&type=template&id=0bcb7e3a"
import script from "./main-form.vue?vue&type=script&lang=ts"
export * from "./main-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports